import SerasaRepository from '@/shared/http/repositories/configurations/serasa.js'

let createSerasaMessage = async (response) => {
  const formatNumberToReal = (value) => {
    let brazilianReal = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    })
    if (!value) return 'NÃO INFORMADO'
    return brazilianReal.format(value.substring(0, value.length - 2))
  }
  try {
    let message = 'INFORMAÇÕES DA CONSULTA SERASA\n'
    let params = (await SerasaRepository.GetParams()).data

    const formatDate = dateString => {
      const options = { year: 'numeric', month: '2-digit', day: '2-digit' }
      return new Date(dateString).toLocaleDateString('pt-BR', options)
    }
    const addInfo = (title, values) => {
      message += `\n${title}\n`
      for (const [key, value] of Object.entries(values)) {
        const formattedValue = key.includes('Data') && value ? formatDate(value) : value || 'NÃO INFORMADO'
        message += `${key}: ${formattedValue}\n`
      }
    }
    if (response.pendenciasPagamento || response.protesto || response.chequeSemFundo) {
      message += '\nATENÇÃO! Pessoa possui seguinte pendências:\n '
      if (response.pendenciasPagamento) message += '• Pendências de Pagamento\n'
      if (response.protesto) message += '• Protesto\n'
      if (response.chequeSemFundo) message += '• Cheque sem Fundo\n'
      if (response.acoesJudiciais) message += '• Ações Judiciais\n'
    }
    if (response.infoCadastraisCreditBureau && params.informacoesCadastrais) {
      let info = response.infoCadastraisCreditBureau
      addInfo('INFORMAÇÕES CADASTRAIS', {
        'Documento': info.document,
        'Situação Documento': info.situacaoDocumento,
        'RG': info.rg,
        'Data de Nascimento': info.dataNascimento,
        'Estado civil': info.estadoCivil,
        'Escolaridade': info.escolaridade,
        'Celular': info.celular,
        'CEP': info.cep,
        'Renda': `${formatNumberToReal(info.renda)}`,
        'Score': `${info.score ? parseInt(info.score) : 'NÃO INFORMADO'}`
      })
    }
    if (response.infoCadastraisRelato && params.informacoesCadastrais) {
      let info = response.infoCadastraisRelato
      addInfo('INFORMAÇÕES CADASTRAIS', {
        'Documento': info.document,
        'Situação Empresa': info.situacaoEmpresa,
        'Razão Social': info.razaoSocial,
        'Nome Fantasia': info.nomeFantasia,
        'CEP': info.cep,
        'E-mail': info.email,
        'Data Fundação': info.dataFundacao,
        'Ramo': info.ramo,
        'Quantidade Empregados': info.quantidadeEmpregados
      })
    }
    if (response.socio && params.informacoesCadastrais) {
      let info = response.socio
      let count = 0
      info.forEach((r) => {
        count++
        let doc = r.documento + (r.digitoControle ? r.digitoControle : '')
        addInfo(`SOCIO ${count}`, {
          'Pessoa': r.tipoPessoa === 'F' ? 'Física' : 'Jurídica',
          'Documento': doc,
          'Nome Socio': r.nomeSocio,
          'Percentual Capital': r.percentualCapital,
          'Data Entrada': r.dataEntrada
        })
      })
    }

    return message
  } catch (err) {
    this.onException(err)
    throw err // rethrow the error to propagate it
  }
}

export { createSerasaMessage }



// WEBPACK FOOTER //
// ./src/components/tools/SerasaTools.js